import {translate} from "../locale";

const DEFAULT_ERROR_CODE = '399999';

const NEED_PARSE_ERROR_CODE_MAP = {
  invalid: '390101',
  expired: '390201', // todo by backend, need backend to support first
  redeemed: '390301',
  check_rule_general: '390499', // free or paid show billing error (from backend)
};

const PRECISE_MSG_MAPPING = {
  // 390101
  [NEED_PARSE_ERROR_CODE_MAP.invalid]: 'freetrial.error.general_msg',
  // 390201
  [NEED_PARSE_ERROR_CODE_MAP.expired]: 'freetrial.error.general_msg',
  // 390301
  [NEED_PARSE_ERROR_CODE_MAP.redeemed]: 'freetrial.error.redeemed',
  // 399999
  [DEFAULT_ERROR_CODE]: 'freetrial.error.general_msg',
};

export class BaseFreeTrialErrorHandler {
  constructor(freeTrialResult = {}) {
    this.freeTrialResult = freeTrialResult;
  }

  getDefaultErrorMessage() {
    return translate(PRECISE_MSG_MAPPING[DEFAULT_ERROR_CODE]);
  }

  getErrorMsgWithErrorCode() {
    const {errorCode = '', errorMessage = ''} = this.freeTrialResult;

    switch (errorCode) {
      case NEED_PARSE_ERROR_CODE_MAP.check_rule_general:
        return errorMessage;
      default:
        if (PRECISE_MSG_MAPPING[errorCode]) {
          return translate(PRECISE_MSG_MAPPING[errorCode]);
        }

        return this.getDefaultErrorMessage();
    }
  }
}
